import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useParams } from "react-router-dom";
import Rating from "../components/ui/Rating";
import Price from "../components/ui/Price";
import Bike from "../components/ui/Bike";
import Slider from "react-slick";
import toast, { Toaster } from "react-hot-toast";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// https://keen-slider.io/examples
// using the thumbnail and lazy load
// https://react-slick.neostack.com/

// Components infomation for books
const BikeInfo = ({ bikes, addToCart, cart }) => {

  // gets the id from the url
  const { id } = useParams();

  // find the specific bike based on the id
  const bike = bikes.find((bike) => +bike.id === +id);

  // function to add the selected cart
  function addItemToCart(bike) {
    addToCart(bike);
    toast.success("Items was added to the cart!");
  }

  // function to check the bike is already in shopping cart
  function bikeExistOnCart() {
    return cart.find((bike) => +bike.id === +id);
    // toast.success("Items was already added to the cart!");
  }

  const settings = {
    infinite: true,
    speed: 100,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // prints the info
  return (
    <div id="books__body">
      <main id="books__main">
        <div className="fa-spinner"></div>
        <div className="books__container">
          <div className="row">
            <div className="book__selected--top">
              <Link to="/bikes" className="book__link">
                <FontAwesomeIcon icon="arrow-left" />
              </Link>
              <Link to="/bikes">
                <h2 className="book__selected--title--top">Bikes</h2>
              </Link>
            </div>
            <div className="book__selected">
              <h3 className="newItems">
                {/* {book.item} */}
                {bike.item}
              </h3>
              <figure className="book__selected">
                <img
                  src={bike.url}
                  alt={bike.title}
                  className="book__selected--img"
                />
              </figure>
              <div className="book__selected--container">
                <div className="book__selected--description">
                  <h2 className="book__selected--title">{bike.title}</h2>
                  <Rating rating={bike.rating} />
                  <div className="book__selected--price">
                    <Price
                      originalPrice={bike.originalPrice}
                      salePrice={bike.salePrice}
                    />
                  </div>
                </div>
                <div className="book__summary">
                  <h3 className="book__summary--title">Summary</h3>
                  <p className="book__summary--para">{bike.details}</p>
                </div>
                {bikeExistOnCart() ? (
                  <Link to={"/Cart"} className="book__link">
                    <button className="btn__checkout">Checkout</button>
                  </Link>
                ) : (
                  <button
                    className="btn__checkout purple"
                    onClick={() => addItemToCart(bike)}
                  >
                    Add to cart
                  </button>
                )}
                <Toaster />
              </div>
            </div>
          </div>
        </div>

        <div className="books__container">
          <div className="row">
            <div className="books__selected--top">
              <h2 className="book__selected--title--top">Recommended Bikes</h2>
            </div>
            {/* <Slider {...settings}> */}
            <div className="books">
              {bikes
                .filter((bike) => bike.rating >= 4 && +bike.id !== +id)
                .slice(0, 4)
                .map((bike) => (
                  <Bike bike={bike} key={bike.id} />
                ))}
            </div>
            {/* </Slider> */}
          </div>
        </div>
      </main>
    </div>
  );
};

export default BikeInfo;
